import * as devisConf from '@/configuration/devisConf';

export function genererCritereRechercheDemande() {
  return {
    auto: '',
    jourDepart: [],
    produitsIds: [],
    reseau: [],
    typesProduits: [],
    types: [devisConf.REGROUPEMENT],
    nePasReafficher: true,
    typesDevisCommandeFacture: [devisConf.TYPE_COMMANDE],
    logisticable: true,
    aIntegrerDansLaLogistique: true,
    datesPrevisionnelDepart: {
      dateDebut: null,
      dateFin: null,
    },
    societeId: null,
    agencesIdProduit: [],
  };
}

export function genererCritereRechercheDemandesLogistiques() {
  return {
    auto: '',
    produits: [],
    typesProduits: [],
  };
}
